<template>
  <div class="w-full relative">
    <!-- 视频区域 -->
    <div class="relative flex h-[70vh] w-full">
      <video :src="aboutus" autoplay muted playsinline loop class="w-screen object-cover block"></video>
      <div class="absolute flex flex-col top-1/2 pl-[9%] z-10 w-[82%] flex items-left justify-center -translate-y-1/2">
        <h1 class="font-alibaba font-bold text-[2.6vw] text-white text-left ">
          {{ contactTexts.title }}
        </h1>
        <h1 class="text-[1.4vw]  font-alibaba leading-[1.6] text-white text-left mt-1.3vw">
          {{ contactTexts.subtitle }}
        </h1>
      </div>
    </div>

    <!-- 用一个相对定位的容器包裹视频和表单 -->
    <div class="relative -mt-[14vh] z-10 ">
      <section class="pb-[2vw] w-[82%] m-auto bg-[#DEE8F7] rounded-[1vw] flex justify-center">
        <!-- 表单内容保持不变 -->
        <div class="flex w-full justify-center">
          <div class="w-[80%]">
            <form ref="formRef" @submit.prevent="submitForm" novalidate class="space-y-6 mt-2.2vw">
              <div>
                <div>
                  <label for="first-name" class="block text-base font-semibold text-gray-800">
                    {{ contactTexts.name }}<span class="text-red-500">*</span>
                  </label>
                  <input type="text" id="first-name" v-model="formData.firstName" @focus="onFormFocus"
                    :placeholder="contactTexts.namePlaceholder" @blur="onBlur('firstName', formData.firstName)"
                    class="mt-2 block w-full rounded-md border-0 bg-white p-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600" />
                </div>
              </div>

              <div>
                <label for="email" class="block text-base font-semibold text-gray-800">
                  {{ contactTexts.email }}<span class="text-red-500">*</span>
                </label>
                <input type="email" id="email" v-model="formData.email" @focus="onFormFocus"
                  :placeholder="contactTexts.emailPlaceholder" @blur="onBlur('email', formData.email)"
                  class="mt-2 block w-full rounded-md border-0 bg-white p-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600" />
              </div>

              <div>
                <label for="company-name" class="block text-base font-semibold text-gray-800">
                  {{ contactTexts.company }}<span class="text-red-500">*</span>
                </label>
                <input type="text" id="company-name" v-model="formData.companyName" @focus="onFormFocus"
                  :placeholder="contactTexts.companyPlaceholder" @blur="onBlur('companyName', formData.companyName)"
                  class="mt-2 block w-full rounded-md border-0 bg-white p-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600" />
              </div>

              <div>
                <label for="looking-for" class="block text-base font-semibold text-gray-800">
                  {{ contactTexts.message }}<span class="text-red-500">*</span>
                </label>
                <textarea @focus="onFormFocus" id="looking-for" v-model="formData.lookingFor"
                  @blur="onBlur('lookingFor', formData.lookingFor)" :placeholder="contactTexts.messagePlaceholder" rows="4"
                  class="mt-2 block w-full rounded-md border-0 bg-white p-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600"></textarea>
              </div>

              <div class="w-full mx-auto  ">
                <div id="recaptcha-container"></div>
              </div>

              <button type="submit" class="w-full justify-center  px-4 py-3 text-lg font-bold text-white bg-[#0D0971]"
                :style="buttonStyle" @mouseover="hovered = true" @mouseleave="hovered = false">
                {{ contactTexts.submit }}
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>

    <!-- 下面的新内容区，跟随表单后自然排布 -->
    <section class="relative w-full mt-5vw">
      <div ref="mapContainer" style="width: 65%; height: 25vw"></div>

      <div class="absolute top-0 right-0 h-full w-[40%] bg-[#FFA200] flex items-center">
        <div class="absolute left-[-18px] transform -rotate-90 -translate-y-[5vw] w-0 h-0 
            border-l-[12px] border-l-transparent 
            border-r-[12px] border-r-transparent 
            border-b-[12px] border-b-[#FFA200]">
        </div>
        <div class="pl-[12%] pr-[8%] text-black">
          <h2 class="text-[1.8vw] lg:text-3xl font-bold">
            {{ contactTexts.headquarters }}
          </h2>
          <p class="mt-4 text-[1vw] lg:text-base font-medium cursor-pointer hover:underline mt-2.5vw"
            @click="openGoogleMap">
            {{ contactTexts.address }}
          </p>
          <div class="flex items-center mt-4 text-[1vw] lg:text-base font-medium">
            <svg class="w-4 h-4 mr-2 fill-current" viewBox="0 0 24 24">
              <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
            </svg>
            <a href="mailto:ailsalin@creston-group.com" class="cursor-pointer hover:underline text-black">
              ailsajin@creston-group.com
            </a>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import aboutus from "@/assets/aboutus.mp4";
import { ref, computed, onMounted, onBeforeUnmount, watch } from "vue";
import { locations } from "../utils/imageData";
import { getAnonymousId } from "../utils/anonymous";
import { getUtmParams, getFirstPageUrl, getLandingPage } from "../utils/utmParams";
import { ElMessage } from "element-plus";
import { AuthService } from "../services/AuthService";
import { API_BASE_URL } from "../config/config";
import { pushToDataLayer } from '../utils/gtm';
import { useHead } from '@vueuse/head';
import { useI18n } from 'vue-i18n';
import { getCTAInfo, clearCTAInfo } from '../utils/ctaTracking';
import { getFormSubmitSuccessParams, getDiagnosticEventParams } from '../utils/leadTracking';

const { locale, messages } = useI18n();

// 获取联系我们的文本
const contactTexts = computed(() => {
  return messages.value[locale.value]?.contactUs || {
    title: 'Contact Us',
    subtitle: 'Get in touch with us',
    name: 'Name',
    email: 'Email',
    company: 'Company',
    message: 'Message',
    submit: 'Submit',
    headquarters: 'Headquarters',
    address: 'Address',
    namePlaceholder: 'Enter your name',
    emailPlaceholder: 'Enter your email',
    companyPlaceholder: 'Enter your company',
    messagePlaceholder: 'Enter your message',
    validationMessages: {
      nameRequired: 'Name is required',
      emailRequired: 'Email is required',
      companyRequired: 'Company is required',
      messageRequired: 'Message is required',
      invalidEmail: 'Invalid email format',
      captchaRequired: 'Please complete the captcha',
      submitSuccess: 'Form submitted successfully',
      submitError: 'Submission failed'
    }
  };
});

// reCAPTCHA 相关
const recaptchaToken = ref('');
const siteKey = ref("6LcSGXUrAAAAAJIyf_G5grJzDCN1yWMv2IXfhcSt");

// reCAPTCHA 回调函数
const onCaptchaVerified = (token: string) => {
  recaptchaToken.value = token;
};

const onCaptchaExpired = () => {
  recaptchaToken.value = '';
};

// 地图相关
const mapContainer = ref<HTMLElement | null>(null);

// 表单 ref 用于 form_view 追踪
const formRef = ref<HTMLElement | null>(null);
let formViewObserver: IntersectionObserver | null = null;
let formViewFired = false;

useHead({
  title: 'Contact Us | Creston Group – Engineering, Logistics & Sourcing from China',
  meta: [
    {
      name: 'description',
      content: 'Contact Creston Group in Shanghai for inquiries about engineering, logistics, sourcing, sales and distribution. Our team is ready to assist clients worldwide.'
    }
  ]
});

// 保存 interval ID 用于清理
let recaptchaInterval: ReturnType<typeof setInterval> | null = null;

onMounted(() => {
  // 检查 window 对象是否存在（SSR 兼容性）
  if (typeof window === 'undefined') {
    console.warn('Window object is not available');
    return;
  }

  pushToDataLayer('page_view', {
    page_location: window.location.href,
    page_title: document.title,
    page_referrer: document.referrer,
  });

  // 设置 form_view 的 Intersection Observer
  // 当表单进入视口 ≥50% 且持续 ≥1秒时触发
  if (formRef.value && 'IntersectionObserver' in window) {
    let visibilityTimer: ReturnType<typeof setTimeout> | null = null;

    formViewObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          // 开始计时，1秒后触发 form_view
          if (!visibilityTimer && !formViewFired) {
            visibilityTimer = setTimeout(() => {
              if (!formViewFired) {
                formViewFired = true;
                // 获取诊断事件参数（包含双归因和 UTM）
                const diagnosticParams = getDiagnosticEventParams();
                pushToDataLayer('form_view', {
                  form_id: 'contact_us_form',
                  form_name: 'Contact Us',
                  ...diagnosticParams,
                });
                // 不再需要观察
                if (formViewObserver) {
                  formViewObserver.disconnect();
                }
              }
            }, 1000);
          }
        } else {
          // 离开视口，取消计时
          if (visibilityTimer) {
            clearTimeout(visibilityTimer);
            visibilityTimer = null;
          }
        }
      });
    }, {
      threshold: 0.5 // 50% 可见
    });

    formViewObserver.observe(formRef.value);
  }

  // 注册回调
  if (window) {
    (window as any).onCaptchaVerified = onCaptchaVerified;
    (window as any).onCaptchaExpired = onCaptchaExpired;
  }

  // 渲染 reCAPTCHA - 添加 DOM 检查和更好的错误处理
  const renderRecaptcha = () => {
    const container = document.getElementById("recaptcha-container");
    if (!container) return;

    const grecaptcha = (window as any).grecaptcha;
    if (grecaptcha && grecaptcha.render) {
      try {
        grecaptcha.render("recaptcha-container", {
          sitekey: siteKey.value,
          callback: onCaptchaVerified,
          "expired-callback": onCaptchaExpired,
        });
      } catch (error) {
        console.error('Error rendering reCAPTCHA:', error);
      }
    }
  };

  // 等待 reCAPTCHA 加载
  let attempts = 0;
  const maxAttempts = 50; // 5 秒超时
  recaptchaInterval = setInterval(() => {
    attempts++;
    const grecaptcha = (window as any).grecaptcha;
    if (grecaptcha && grecaptcha.render) {
      if (recaptchaInterval) clearInterval(recaptchaInterval);
      recaptchaInterval = null;
      renderRecaptcha();
    } else if (attempts >= maxAttempts) {
      if (recaptchaInterval) clearInterval(recaptchaInterval);
      recaptchaInterval = null;
      console.warn('reCAPTCHA failed to load after 5 seconds');
    }
  }, 100);

  const init = () => {
    if (mapContainer.value) {
      const map = new google.maps.Map(mapContainer.value, {
        center: { lat: 31.07060136083483, lng: 121.39264145767085 },
        zoom: 14,
        mapTypeControl: false,
        language: locale.value,
        region: locale.value === 'vi' ? 'VN' : 'US',
      });

      google.maps.event.addListenerOnce(map, 'idle', () => {
        const mapDiv = map.getDiv();
        const width = mapDiv.offsetWidth;
        map.panBy(width * 0.00, 0);
      });

      const marker = new google.maps.Marker({
        position: { lat: 31.07060136083483, lng: 121.39264145767085 },
        map,
        title: 'Creston Group China Headquarters',
      });

      marker.addListener('click', openGoogleMap);
    }
  };

  if (window.google && window.google.maps) {
    init();
  } else {
    (window as any).initMap = init;
  }
});

// 组件卸载时清理
onBeforeUnmount(() => {
  // 清理 reCAPTCHA interval
  if (recaptchaInterval) {
    clearInterval(recaptchaInterval);
    recaptchaInterval = null;
  }

  // 清理 form_view observer
  if (formViewObserver) {
    formViewObserver.disconnect();
    formViewObserver = null;
  }

  // 清理全局回调函数
  if (typeof window !== 'undefined') {
    delete (window as any).onCaptchaVerified;
    delete (window as any).onCaptchaExpired;
    delete (window as any).initMap;
  }
});

function onBlur(field: string, value: string) {
  const safeValue = value?.trim() || 'empty';
  pushToDataLayer('blur', {
    category: 'Form Input',
    field,
    value: safeValue,
  });
}

const formStarted = ref(false);
function onFormFocus() {
  if (!formStarted.value) {
    formStarted.value = true;
    // 获取诊断事件参数（包含双归因和 UTM）
    const diagnosticParams = getDiagnosticEventParams();
    pushToDataLayer('form_start', {
      form_id: 'contact_us_form',
      form_name: 'Contact Us',
      form_start_time: new Date().toISOString(),
      ...diagnosticParams,
    });
  }
}

function openGoogleMap() {
  const address = '248 Guanghua Road, Minhang District, Shanghai';
  const roomInfo = 'Room 205, 2nd Floor';
  const query = encodeURIComponent(`${address} (${roomInfo})`);
  window.open(`https://www.google.com/maps/search/?api=1&query=${query}`, '_blank');

  pushToDataLayer('blur', {
    category: 'Form Input',
    field: 'openGoogleMap',
    value: 'clicked',
  });
}

const hovered = ref(false);
const contacts = ref([]);

const buttonStyle = computed(() => ({
  boxShadow: hovered.value ? "0px 0px 20px 0px #0D0971" : "none",
  transition: "box-shadow 0.3s ease",
}));

// Define the shape of our form data with TypeScript
interface FormData {
  firstName: string;
  email: string;
  companyName: string;
  lookingFor: string;
  captchaToken: string;
}

// Initialize form data with refs
const formData = ref<FormData>({
  firstName: "",
  email: "",
  companyName: "",
  lookingFor: "",
  captchaToken: "",
});

let authToken: string | null = null;
let tokenExpiresAt: number | null = null;

const requiredFields = [
  { key: 'firstName', label: contactTexts.value.name, validationKey: 'nameRequired' },
  { key: 'email', label: contactTexts.value.email, validationKey: 'emailRequired' },
  { key: 'companyName', label: contactTexts.value.company, validationKey: 'companyRequired' },
  { key: 'lookingFor', label: contactTexts.value.message, validationKey: 'messageRequired' },
];

// Form submission handler
const isValidEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

const submitForm = async () => {
  // 获取诊断事件参数（用于 form_error_* 事件）
  const diagnosticParams = getDiagnosticEventParams();

  // 必填项校验
  for (const field of requiredFields) {
    if (!formData.value[field.key]) {
      // 🔴 form_error_missingRequiredFields: 必填字段缺失
      pushToDataLayer('form_error_missingRequiredFields', {
        form_id: 'contact_us_form',
        form_name: 'Contact Us',
        error_message: `Required field missing: ${field.key}`,
        field_name: field.key,
        ...diagnosticParams,
      });
      ElMessage({
        message: contactTexts.value.validationMessages?.[field.validationKey] || `Please fill out the "${field.label}" field.`,
        type: "warning",
      });
      return;
    }
  }

  // 校验 Email 格式合法性
  if (!isValidEmail(formData.value.email)) {
    // 🔴 form_error_missingRequiredFields: Email 格式无效也属于必填字段问题
    pushToDataLayer('form_error_missingRequiredFields', {
      form_id: 'contact_us_form',
      form_name: 'Contact Us',
      error_message: 'Invalid email format',
      field_name: 'email',
      ...diagnosticParams,
    });
    ElMessage({
      message: contactTexts.value.validationMessages?.invalidEmail || 'Please enter a valid email address.',
      type: "warning",
    });
    return;
  }

  // reCAPTCHA 校验
  if (!recaptchaToken.value) {
    // 🔴 form_error_recaptchaNotCompleted: reCAPTCHA 未完成
    pushToDataLayer('form_error_recaptchaNotCompleted', {
      form_id: 'contact_us_form',
      form_name: 'Contact Us',
      error_message: 'Captcha not completed',
      field_name: 'captcha',
      ...diagnosticParams,
    });
    ElMessage({
      message: contactTexts.value.validationMessages?.captchaRequired || 'Please complete the reCAPTCHA verification.',
      type: "warning",
    });
    return;
  }

  // 获取 UTM 参数
  const utmParams = getUtmParams();

  const payload = {
    data: {
      FirstName: formData.value.firstName,
      Email: formData.value.email,
      CompanyName: formData.value.companyName,
      LookFor: formData.value.lookingFor,
      anonymous_id: getAnonymousId(),
      captchaToken: recaptchaToken.value,
      // UTM 参数 (hidden fields)
      utm_source: utmParams.utm_source,
      utm_medium: utmParams.utm_medium,
      utm_campaign: utmParams.utm_campaign,
      utm_campaign_id: utmParams.utm_campaign_id,
      utm_adgroup: utmParams.utm_adgroup,
      utm_adgroup_id: utmParams.utm_adgroup_id,
      utm_ad: utmParams.utm_ad,
      utm_matchtype: utmParams.utm_matchtype,
      utm_device: utmParams.utm_device,
      utm_term: utmParams.utm_term,
      // URL Snapshot fields (hidden fields)
      first_page_url: getFirstPageUrl(),
      landing_page: getLandingPage(),
      // 时间 & 技术补充字段 (hidden fields)
      lead_submit_time: new Date().toISOString(),
      user_agent: navigator.userAgent,
    },
  };

  // 获取 CTA 信息（提前获取，用于 form_submit 和 form_submit_success）
  const ctaInfo = getCTAInfo();

  // 获取表单提交事件的完整参数（包含 lead_id, 双归因参数, UTM 等）
  const submitParams = getFormSubmitSuccessParams('contact_us_form', 'Contact Us');

  // 🔴 form_submit: 发送请求时触发（用户点击提交按钮）
  pushToDataLayer('form_submit', {
    ...submitParams,
    cta_location: ctaInfo?.cta_location || 'contact_page',
    cta_type: ctaInfo?.cta_type || 'direct',
  });

  try {
    const response = await fetch(`${API_BASE_URL}/api/contact-uses`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    const result = await response.json();

    if (!response.ok) {
      console.error("Submission failed:", result);

      const errorMessage = result.error?.message || 'Unknown error';

      // 判断是否为 reCAPTCHA 验证失败
      const isRecaptchaError =
        errorMessage.toLowerCase().includes('recaptcha') ||
        errorMessage.toLowerCase().includes('captcha') ||
        errorMessage.toLowerCase().includes('g-recaptcha-response') ||
        errorMessage.toLowerCase().includes('expired token') ||
        errorMessage.toLowerCase().includes('invalid token') ||
        errorMessage.toLowerCase().includes('missing token') ||
        errorMessage.toLowerCase().includes('no recaptcha token');

      if (isRecaptchaError) {
        // 🔴 form_error_recaptchaVerificationFailed: reCAPTCHA 服务器验证失败
        pushToDataLayer('form_error_recaptchaVerificationFailed', {
          form_id: 'contact_us_form',
          form_name: 'Contact Us',
          error_message: `reCAPTCHA verification failed: ${errorMessage}`,
          field_name: 'captcha',
          http_status: response.status,
          ...diagnosticParams,
        });
      } else {
        // 🔴 form_error_httpRequestFailed: HTTP 错误（4xx/5xx）
        pushToDataLayer('form_error_httpRequestFailed', {
          form_id: 'contact_us_form',
          form_name: 'Contact Us',
          error_message: `HTTP request failed: ${response.status} - ${errorMessage}`,
          field_name: 'api_response',
          http_status: response.status,
          ...diagnosticParams,
        });
      }

      alert("Submission failed. Please try again.");
      return;
    }

    // 🔴 form_submit_success: 接口成功后触发
    pushToDataLayer('form_submit_success', {
      ...submitParams,
      cta_location: ctaInfo?.cta_location || 'contact_page',
      cta_type: ctaInfo?.cta_type || 'direct',
    });

    // 清除 CTA 信息
    clearCTAInfo();

    ElMessage({
      message: contactTexts.value.validationMessages?.submitSuccess || 'Thank you for reaching out. A Creston representative will be in touch shortly.',
      type: "success",
    });

    Object.assign(formData.value, {
      firstName: '',
      email: '',
      companyName: '',
      lookingFor: '',
      anonymous_id: '',
    });

    // 重置 captcha
    if (typeof grecaptcha !== 'undefined' && grecaptcha.reset) {
      grecaptcha.reset();
      recaptchaToken.value = '';
    }

  } catch (error) {
    console.error("Error submitting form:", error);

    // 🔴 form_error_httpRequestFailed: 网络错误或请求失败
    pushToDataLayer('form_error_httpRequestFailed', {
      form_id: 'contact_us_form',
      form_name: 'Contact Us',
      error_message: `Network error: ${error instanceof Error ? error.message : 'Unknown error'}`,
      field_name: 'network',
      error_type: 'network_error',
      ...diagnosticParams,
    });

    ElMessage({
      message: contactTexts.value.validationMessages?.submitError || 'Submission failed. Please try again later.',
      type: "error",
    });
  }
};

// 添加地图重新加载函数
const reloadMapWithLanguage = (lang: string) => {
  // 移除现有的地图脚本
  const existingScript = document.querySelector('script[src*="maps.googleapis.com"]');
  if (existingScript) {
    existingScript.remove();
  }
  
  // 重新加载带有新语言的地图脚本
  const script = document.createElement('script');
  script.src = `https://maps.googleapis.com/maps/api/js?key=YOUR_API_KEY&callback=initMap&language=${lang}`;
  script.async = true;
  script.defer = true;
  document.head.appendChild(script);
  
  (window as any).initMap = init;
};

// 监听语言变化
watch(locale, (newLocale) => {
  reloadMapWithLanguage(newLocale);
});
</script>

<style scoped>
input:-webkit-autofill {
  background-color: white !important;
  -webkit-box-shadow: 0 0 0px 1000px white inset !important;
  -webkit-text-fill-color: #111827 !important;
}
</style>
